import React from 'react';
import { Check } from 'lucide-react';
import { AGENT } from '@/data/agent';
import { LANDING } from '@/constants/testIds';

const Areas = () => {
  return (
    <section
      data-testid={LANDING.areas}
      className="bg-bayleys-cream"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-20 lg:py-28">
        <div className="max-w-2xl">
          <div className="bayleys-divider mb-6" />
          <p className="text-xs tracking-[0.3em] uppercase text-bayleys-navy/70 font-medium mb-5">
            Service Areas
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-bayleys-navy leading-[1.05] tracking-tight">
            Across the<br />Hibiscus Coast.
          </h2>
          <p className="mt-6 text-lg text-bayleys-navy/80 font-normal leading-relaxed">
            Local expertise across the suburbs Kaid knows best — from coastal pockets to new-build communities.
          </p>
        </div>

        <ul className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-4">
          {AGENT.areas.map((area) => (
            <li
              key={area}
              data-testid={LANDING.areaItem}
              className="group flex items-center gap-3 py-3 border-b border-bayleys-navy/15 transition-colors duration-200 hover:border-bayleys-navy"
            >
              <span className="flex items-center justify-center w-6 h-6 bg-bayleys-navy text-white shrink-0">
                <Check className="w-3.5 h-3.5" strokeWidth={3} />
              </span>
              <span className="text-base sm:text-lg text-bayleys-navy font-normal">
                {area}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Areas;
